import React, { FC } from 'react';

import Loadable from 'react-loadable';

import { HiddenLoader } from 'src/components/react-loadable';

import { ForgeRepoPullRequestActionSingleAppProps } from './repo-pull-request-action-single-app';

const LoadableDropdownSingleApp = Loadable({
  loading: HiddenLoader,
  loader: () => import('./repo-pull-request-action-single-app'),
});

/* eslint @typescript-eslint/ban-types: "warn" */
export const LazyForgeRepoPullRequestActionSingleApp: FC<
  Omit<ForgeRepoPullRequestActionSingleAppProps, 'currentUser' | 'repository'>
> = props => {
  return <LoadableDropdownSingleApp {...props} />;
};
